import React from 'react';
import './GiftListComponent.scss'
import Config from "../../asstes/js/Config";
import {setSessionCache} from "../../asstes/js/Utils";

class GiftListComponent extends React.Component {
	state = {
		imgBg: false
	}

	UNSAFE_componentWillMount() {
		this.selectLock = false
	}

	componentWillUnmount() {
		this.selectLock = true
	}

	selectRewardIdx(idx) {
		if (this.selectLock) return
		this.selectLock = true
		Config.selectMouse = idx
		setSessionCache('selectMouse', idx)
		this.props.selectRewardIdx && this.props.selectRewardIdx(idx)
		setTimeout(() => {
			this.selectLock = false
		}, 200)
	}

	imgLoad = () => {
		this.setState({
			imgBg: true
		})
	}

	render() {
		const giftListBg = require('../../asstes/img/Index/git-list-bg.png')
		const selectPointer = require('../../asstes/img/Index/success-seelct-pointer.png')
		const arr = [1, 2, 3]
		const {selectIdx} = this.props
		const giftList = [
			require('../../asstes/img/Index/gift-list/gift-list1.png'),
			require('../../asstes/img/Index/gift-list/gift-list2.png'),
			require('../../asstes/img/Index/gift-list/gift-list3.png'),
			require('../../asstes/img/Index/gift-list/gift-list4.png'),
			require('../../asstes/img/Index/gift-list/gift-list5.png'),
			require('../../asstes/img/Index/gift-list/gift-list6.png'),
		]
		const giftListActive = [
			require('../../asstes/img/Index/gift-list/gift-list1-active.png'),
			require('../../asstes/img/Index/gift-list/gift-list2-active.png'),
			require('../../asstes/img/Index/gift-list/gift-list3-active.png'),
			require('../../asstes/img/Index/gift-list/gift-list4-active.png'),
			require('../../asstes/img/Index/gift-list/gift-list5-active.png'),
			require('../../asstes/img/Index/gift-list/gift-list6-active.png'),
		]

		return <div className="gift-list-container">
			<img src={giftListBg} alt=""/>
			<div className="absolute-gift-list-container flex-between-center">
				{/* 上三层锦盒 */}
				<div className="gift-list-line flex-center-center">
					{
						arr.map((item, idx) => {
							return <div className="gift-img-div" key={idx} data-a={item}
							            onClick={() => this.selectRewardIdx(idx)}>
								{
									idx !== selectIdx ?
										<img src={giftList[idx]} alt=""/> :
										<>
											<img src={giftListActive[idx]} alt=""/>
											<img className="select-pointer" src={selectPointer} alt=""/>
										</>
								}
							</div>
						})
					}
				</div>
				{/* 下三层锦盒 */}
				<div className="gift-list-line flex-center-center">
					{
						arr.map((item, idx) => {
							return <div className="gift-img-div" key={idx} data-a={item}
							            onClick={() => this.selectRewardIdx(idx + 3)}>
								{
									idx + 3 !== selectIdx ?
										<img src={giftList[idx + 3]} alt=""/> :
										<>
											<img src={giftListActive[idx + 3]} alt=""/>
											<img className="select-pointer" src={selectPointer} alt=""/>
										</>
								}
							</div>
						})
					}
				</div>
			</div>
		</div>
	}
}

export default GiftListComponent;
